import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {KeycloakService} from 'keycloak-angular';
import {AtcDTO} from '../../../models/AtcDTO';
import {AtcService} from 'src/app/modules/pbm/services/atc.service';
import {SharedService} from '../../../../common/services/shared-service';

@Component({
  selector: 'app-add-atc-dialog',
  templateUrl: './add-atc-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class AddAtcDialogComponent implements OnInit {

  codeFormControl: FormControl;
  nameFormControl: FormControl;
  levelFormControl: FormControl;
  sourceFormControl: FormControl;

  atcFormGroup: FormGroup;

  editAtc = new AtcDTO();
  isEdit = false;
  userFirstLastName = '';
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<AddAtcDialogComponent>,
    private formBuilder: FormBuilder,
    private atcService: AtcService,
    private keycloakService: KeycloakService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public id: number
  ) {

    this.codeFormControl = new FormControl('');
    this.nameFormControl = new FormControl('');
    this.levelFormControl = new FormControl('');
    this.sourceFormControl = new FormControl('');

    this.atcFormGroup = this.formBuilder.group({
      code: this.codeFormControl,
      name: this.nameFormControl,
      level: this.levelFormControl,
      source: this.sourceFormControl
    });

    if (id != null) {
      this.isEdit = true;
      this.getAtcCode(id);
    }
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  onSaveClick(): void {
    if (this.atcFormGroup.valid) {
      const atcDTO = new AtcDTO();
      atcDTO.code = this.codeFormControl.value;
      atcDTO.name = this.nameFormControl.value;
      atcDTO.level = 1; // TODO: refractor into NameValueDTO
      atcDTO.levelDescription = this.levelFormControl.value;
      atcDTO.source = this.sourceFormControl.value;

      if (this.isEdit) {
        atcDTO.atcId = this.editAtc.atcId;
        atcDTO.created = this.editAtc.created;
        atcDTO.createdBy = this.editAtc.createdBy;
        atcDTO.updated = new Date();
        atcDTO.updatedBy = this.userFirstLastName;
      }
      else {
        atcDTO.created = new Date();
        atcDTO.createdBy = this.userFirstLastName;
      }

      this.atcService.saveAtcCode(atcDTO).subscribe(
        response => {
          this.sharedService.openSnackBar(`ATC ${response.name} saved successfully`, 'Dismiss');
          this.dialogRef.close();
        },
        errorResponse => {
          const error = errorResponse.error;
          this.errorMessage = error.businessMessage;
        }
      );
    }
    else {
      this.errorMessage = 'Please complete all required fields.';
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  getAtcCode(id: number) {
    this.atcService.getAtcCode(id).subscribe(
      response => {
        this.editAtc = response;
        this.codeFormControl.setValue(this.editAtc.code);
        this.nameFormControl.setValue(this.editAtc.name);
        this.levelFormControl.setValue(this.editAtc.levelDescription);
        this.sourceFormControl.setValue(this.editAtc.source);
      }
    );
  }

}
